import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';

import { ButtonStyled, IconWrapStyled } from './Button.styled';
import ButtonLoader from './components/ButtonLoader/ButtonLoader';

type ButtonPropsT = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'contained' | 'outline' | 'outline-rounded' | 'text';
  weight?: 'normal' | 'semibold' | 'bold';
  icon?: ReactNode;
  iconHoverColor?: 'black' | 'white' | 'darkBlue' | 'blue';
  isLoading?: boolean;
  loaderVariant?: 'round' | 'brick';
  loaderColor?: 'white' | 'darkBlue';
};

const Button = forwardRef<HTMLButtonElement, ButtonPropsT>(
  ({ children, icon, loaderColor, loaderVariant, isLoading = false, ...restProps }, ref) => {
    const hasIcon = !!icon;

    return (
      <ButtonStyled isLoading={isLoading} hasIcon={hasIcon} ref={ref} {...restProps}>
        <>
          {hasIcon && !isLoading && <IconWrapStyled>{icon}</IconWrapStyled>}
          {isLoading ? <ButtonLoader variant={loaderVariant} color={loaderColor} /> : children}
        </>
      </ButtonStyled>
    );
  }
);

export default Button;
